// extracted by mini-css-extract-plugin
export default {"pagePreloaderWrapper":"PagePreloader_pagePreloaderWrapper__QgvUG"};